// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"146":"eaa148f7","787":"deeec6c3"}[chunkId] + ".chunk.js";
};